import { IFavorite } from '~src/favorites/types/IFavorite';
import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';

export interface IGetFavoritesResult extends IGetItemsResult {
  favorites: IFavorite[];
}

export class GetFavoritesRequest extends Request<IGetItemsParams, IGetFavoritesResult> {
  constructor(params: IGetItemsParams) {
    super('getFavorites', params);
  }
}
